import Loading from '@/components/Loading'
import LoginSignup from '@/components/LoginSignup'
import { Unauthenticated, Authenticated } from '@/utils/auth/auth'
import { getCurrentUser } from '@/utils/auth/UserProvider'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { useFocusManagement } from '@/utils/hooks/useFocusManagement'
import { usePageTitle } from '@/utils/hooks/usePageTitle'

export default function NotFound() {
  usePageTitle('Page Not Found')
  const { isLoading: userLoading, orgs } = getCurrentUser()
  const focusRef = useFocusManagement()

  if (userLoading) {
    return <Loading />
  }

  if (!userLoading && orgs && orgs.length === 0) {
    window.location.href = '/'
  }

  return (
    <>
      <Unauthenticated>
        <LoginSignup />
      </Unauthenticated>
      <Authenticated>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            width: '70%',
            margin: '0 auto',
          }}
        >
          <Typography
            variant="h1"
            component="h1"
            ref={focusRef}
            tabIndex={-1}
            sx={{
              mb: 4,
              fontSize: '34px',
              mt: 20,
              '&:focus': {
                outline: 'none',
              },
            }}
          >
            Page Not Found
          </Typography>
          <Typography variant="h6">
            Sorry! We couldn't find the page you were looking for...
          </Typography>

          <Button
            color="inherit"
            component={Link}
            disableRipple
            to="/"
            sx={{
              color: '#212121',
              textDecoration: 'underline',
              textTransform: 'none',
              fontSize: '20px',
              '&:hover': {
                backgroundColor: 'transparent',
                boxShadow: 'none',
                textDecoration: 'underline',
                '&:focus': {
                  backgroundColor: '#e8e8e8',
                },
              },
              cursor: 'pointer',
            }}
          >
            Return Home
          </Button>
        </Box>
      </Authenticated>
    </>
  )
}
